export default "__VITE_ASSET__b2080077__"